import { buildTreeNodes } from "Common/treeViewUtils/treeViewUtils";
import forEach from "lodash/forEach";
import isNaN from "lodash/isNaN";
import map from "lodash/map";
import replace from "lodash/replace";
import permissionsTree from "./permissionsTree";
export const checkMask = (mask, sourcePermission) => {
    const stringMask = mask.toString(2);
    const permission = +sourcePermission;
    return (!isNaN(permission) &&
        new RegExp(`${replace(permission.toString(2), /0/g, ".")}$`).test(stringMask));
};
export const getPlainArray = (source, result) => {
    forEach(source, e => {
        result.push(e);
        if (e.items) {
            getPlainArray(map(e.items, item => ({ ...item, text: `${e.text}. ${item.text}` })), result);
        }
    });
};
export const getPermissionsFromMask = (mask) => {
    const permissionsArray = [];
    const result = [];
    getPlainArray(permissionsTree, permissionsArray);
    forEach(permissionsArray, e => {
        if (checkMask(mask, e.id)) {
            result.push(e);
        }
    });
    return result.map(e => ({ id: e.id, text: e.text }));
};
export const buildPermissionsTree = (checkedPermissions = [], expandedPermissions = []) => buildTreeNodes(permissionsTree, checkedPermissions, expandedPermissions);
